import React, { useState } from "react";
import "./Career.css";
import { Container, Row, Col, Button, Form } from "react-bootstrap";

const Career = () => {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    position: "",
    message: "",
    resume: null,
  });

  const jobs = [
    {
      title: "Music Distribution Manager",
      location: "Delhi, India",
      type: "Full Time",
    },
    {
      title: "Artist Relations Executive",
      location: "Delhi, India",
      type: "Full Time",
    },
    {
      title: "Digital Marketing Specialist",
      location: "Delhi, India",
      type: "Full Time",
    },
    {
      title: "Content & Social Media Intern",
      location: "Delhi, India",
      type: "Internship",
    },
  ];

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log(formData);

    alert("Application Submitted Successfully!");
  };

  return (
    <div className="careers-page">

      {/* HERO */}
      <section className="career-hero">
        <Container>
          <h1>Join The FT Tunes Team</h1>
          <p>
            Help independent artists reach the world. Build the future of music
            distribution with us.
          </p>
        </Container>
      </section>

      {/* WHY FT TUNES */}
      <section className="career-about">
        <Container>
<Row className="career-about-row">
  <Col md={6}>
    <div className="career-about-left">
      <h2>Why Work With FT Tunes?</h2>
      <p>
        FT Tunes empowers artists globally through innovative music
        distribution, promotion, and technology.
      </p>
    </div>
  </Col>

  <Col md={6}>
    <div className="career-about-right">
      <ul className="career-benefits">
        <li>🎵 Work in the Music Industry</li>
        <li>🌍 Remote Friendly Culture</li>
        <li>🚀 Fast Growth Opportunities</li>
        <li>💡 Creative Environment</li>
        <li>🤝 Collaborative Team</li>
      </ul>
    </div>
  </Col>
</Row>
        </Container>
      </section>

      {/* JOB LIST */}
      <section className="career-jobs">
        <Container>
          <h2 className="text-center">Open Positions</h2>

          {jobs.map((job, index) => (
            <div key={index} className="job-card">
              <div>
                <h4>{job.title}</h4>
                <p>{job.location} • {job.type}</p>
              </div>

                <Button
                className="apply-btn"
                onClick={() => {
                    setFormData({ ...formData, position: job.title });

                    document
                    .getElementById("career-form")
                    ?.scrollIntoView({ behavior: "smooth" });
                }}
                >
                Apply Now
                </Button>
            </div>
          ))}
        </Container>
      </section>

      {/* APPLY FORM */}
      <section className="career-form" id="career-form">
        <Container>
          <h2 className="text-center">Apply For Position</h2>

          <Form onSubmit={handleSubmit} className="career-apply-form">

            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    required
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    required
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    type="text"
                    name="phone"
                    required
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Position</Form.Label>
                  <Form.Control
                    type="text"
                    name="position"
                    value={formData.position}
                    onChange={handleChange}
                    placeholder="Select from above"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group>
              <Form.Label>Upload Resume</Form.Label>
              <Form.Control
                type="file"
                name="resume"
                accept=".pdf,.doc,.docx"
                required
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="message"
                onChange={handleChange}
              />
            </Form.Group>

            <div className="text-center mt-4">
              <Button type="submit" className="apply-btn big">
                Submit Application
              </Button>
            </div>

          </Form>
        </Container>
      </section>

      {/* CTA */}
      <section className="career-cta">
        <Container>
          <h2>Don't See Your Role?</h2>
          <p>Send your portfolio & resume — we are always hiring talent.</p>

          <a href="mailto:music@fttunes.com">
            <Button className="apply-btn big">
              Send Resume
            </Button>
          </a>
        </Container>
      </section>

    </div>
  );
};

export default Career;